
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"33","height":"39","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M6.116 8.376c-1.305.775-1.305 2.664 0 3.439l12.369 7.344c1.333.791 3.02-.17 3.02-1.72v-5.575a12 12 0 11-16.379 6.8 2 2 0 10-3.763-1.355 16 16 0 1020.143-9.747v-4.81c0-1.55-1.688-2.512-3.021-1.72L6.116 8.376z","fill":"#fff"}})])
          )
        }
      }
    